/**
 * Created by weid on 2017/8/30.
 */
/**
 * injectAsyncReducer({
 *      store,
 *      key: 'agency',
 *      reducer: require('exampleModule/reducers/agency').default
 * });
 */
import { createReducer } from './createReducer';
import { createQmyxReducer } from './createQmyxReducer';

export const injectAsyncReducer = ({ store, key, reducer }) => {
    if (key in store.getState()) {
        if (!reducer.inject) {
            console.error(`\`${key}\` already exists in root state.`);
        }
        return;
    }
    reducer.inject = true;
    store.asyncReducers[key] = reducer;

    const newCreateReducer = key === 'qmyx' ? createQmyxReducer : createReducer;
    store.replaceReducer(newCreateReducer(store.asyncReducers));
};



// WEBPACK FOOTER //
// ./src/rootRedux/reducers/injectAsyncReducer.js